import React, { Suspense } from "react";
import { ContentRoute, LayoutSplashScreen } from "../../../../_metronic/layout";
import { Redirect, Switch } from "react-router-dom";
import { Permissions, PermissionType } from "../../../util/Permissions";

import { CreatePlan } from "./create-plan/CreatePlan";






export default function SafeLockManagement() {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <div className="py-4 px-6">
                <Switch>
                    {
                        // /* Redirect from /theme root URL to /safelocks */
                        <Redirect
                            exact={true}
                            from="/overview/safeLocks"
                            to="/overview/safeLocks/view"
                        />
                    }
                    <ContentRoute path="/overview/safeLocks/create" permission={Permissions.SAFE_LOCK} permissionType={PermissionType.CREATE} component={CreatePlan} />
    
        
                </Switch>
            </div>
        </Suspense>
    );
}